import React from "react"
import { CenterPiece, Footer, Main } from "../styles"
import { useTurn } from "../../shared/hooks/useTurn"
import { Players } from "../players/Players"
import styled from "styled-components"
import getMediaUrl from '../../../utils/mediaUrl'

const QuestionDiv = styled.div`
  background-image: url(${props => props.backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  place-items: center;
  place-content: center;
`

const MessageDiv = styled.div`
  display: flex;
  justify-content: space-between;
`
export const TurnQuestion = props => {
  const { error, roundData, turnData, labels, gameProps } = useTurn()
  if (error) return <div>{error}</div>

  const turn_title = turnData?.turn_title || ""
  const turn_player_title = turnData?.turn_role_if_normal?.title || ""
  const turn_status = `${turn_player_title} ${labels.turn_player_reads_card}`

  const turn_host_screen = turnData?.turn_host_screen

  const mainImage =
    turn_host_screen?.host_background_image || roundData?.host_background_image
  const mainImageUrl = getMediaUrl(gameProps?.strapiUrl, mainImage?.url)
  const mainImageAlt = mainImage?.alternativeText || ""

  const questionImage = turn_host_screen?.host_question_image || null
  const questionImageUrl = getMediaUrl(gameProps?.strapiUrl, questionImage?.url)
  const questionImageAlt = questionImage?.alternativeText || ""

  const centerTitle = turn_host_screen?.host_title || ""
  const centerText = turn_host_screen?.host_description || ""
  const hasCenterContent = centerText || centerTitle

  const message = (
    <MessageDiv>
      <div>{turn_status}</div>
      <div>{turn_title}</div>
    </MessageDiv>
  )

  return (
    <Main backgroundImage={mainImageUrl}>
      <span role="img" aria-label={mainImageAlt}></span>
      <QuestionDiv backgroundImage={questionImageUrl}>
        <span role="img" aria-label={questionImageAlt}></span>
        {hasCenterContent && (
          <CenterPiece>
            <h1>{centerTitle}</h1>
            <div>{centerText}</div>
          </CenterPiece>
        )}
      </QuestionDiv>
      <Footer>
        <Players message={message} />
      </Footer>
    </Main>
  )
}
